import { useQuery } from "@tanstack/react-query";
import { useGeotabClient } from "@/components/GeotabClientContext";
import { RESULTS_LIMIT_RANGE_ESTIMATE } from "@/constants/resultsLimits";

export interface RangeEstimate {
  device: { id: string };
  vin: string;
  detectionDate: string;
  rangeEstimateMeanKm: number;
  rangeEstimateLowerBoundKm: number;
  rangeEstimateUpperBoundKm: number;
  rangeEstimationMethod: string;
}

export function useRangeEstimate(deviceId: string) {
  const { geotabClient, activeSessionId } = useGeotabClient();

  const toDate = new Date();
  const fromDate = new Date(toDate);
  fromDate.setFullYear(fromDate.getFullYear() - 1);

  return useQuery({
    queryKey: ["rangeEstimate", activeSessionId, deviceId],

    queryFn: ({ signal }): Promise<RangeEstimate[]> => {
      return geotabClient.call(
        "Get",
        {
          typeName: "RangeEstimate",
          search: {
            deviceSearch: { id: deviceId },
            fromDate: fromDate.toISOString(),
            toDate: toDate.toISOString(),
          },
          resultsLimit: RESULTS_LIMIT_RANGE_ESTIMATE,
        },
        signal,
      );
    },

    enabled: !!deviceId,
    staleTime: 10 * 60 * 1000,
  });
}
